import Email from './Email';
import Reset from './Reset';
import Crm from './Crm';
import Subscriptions from './Subscriptions';
import Container from './FragmentContainer';
export default {
  Container: Container,
  Email: Email,
  Subscriptions: Subscriptions,
  Reset: Reset,
  Crm: Crm
};